import { combineReducers } from 'redux';
import prReducer from '../services/benit/pages/state/reducers';
import benitCentralUIReducer from '../services/benit/central-ui/state/reducers';

const reducers = combineReducers({
    prReducer,
    benitCentralUIReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
